// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__uwm5e","slideIn":"Menu_slideIn__6jTXG","header":"Menu_header__3ysn8","logo":"Menu_logo__2nmmA","close":"Menu_close__ZuLp2","list":"Menu_list__Yu4Dj"};